import { type DeliveryClass, DELIVERY_CLASS } from '@hooks-api/types/dataModel/shipping'
import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { wpCartInstance } from '../../i18n/wpCartInstance'

const DeliveryClassMap: Partial<Record<DeliveryClass, [string, object]>> = {
  [DELIVERY_CLASS.NORMAL]: ['wpCart.normal', { defaultValues: '常溫' }],
  [DELIVERY_CLASS.FROZEN]: ['wpCart.frozen', { defaultValues: '冷凍' }],
  [DELIVERY_CLASS.SUBSHIP]: ['wpCart.subship', { defaultValues: '寄倉/訂閱' }],
  [DELIVERY_CLASS.DONATION]: ['wpCart.donation', { defaultValues: '公益' }],
}

export interface ShippingListItemRuleProps {
  description?: ReactNode
  deliveryClass?: DeliveryClass
}

export const ShippingListItemRule = (props: ShippingListItemRuleProps) => {
  const { deliveryClass, description } = props
  const { t } = useTranslation('wpCart', { i18n: wpCartInstance })
  const deliveryClassTranslationConfig = deliveryClass ? DeliveryClassMap[deliveryClass] : null

  return (
    <HStack gap={1} alignItems="flex-start" flexWrap="nowrap">
      {deliveryClass && deliveryClassTranslationConfig && <Chip variant="square" size="small" color={deliveryClass === 'frozen' ? 'blue' : 'default'}>{t(...deliveryClassTranslationConfig)}</Chip>}
      <Text color={colors.grey600}>
        {description}
      </Text>
    </HStack>
  )
}
